function payload(item, key, defaultVal = '') {
  const found = item.payloads.find(x => x.key === key);
  return found ? found.value : defaultVal;
}

export default { payload };